export const multiselect = {
  root: {
    background: 'transparent',
    border: {
      color: 'transparent',
    },
  },
};
